import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileText, CheckCircle, AlertCircle } from 'lucide-react';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F4ECDE] py-12 px-4 font-sans text-[#471F21]">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12">
        {/* Header */}
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-gray-600 hover:text-[#471F21] mb-8 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Home
        </button>

        <div className="border-b-2 border-[#471F21]/10 pb-6 mb-8">
          <h1 className="text-3xl md:text-4xl font-serif font-bold mb-4">Terms & Conditions</h1>
          <p className="text-gray-600">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</p>
        </div>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-[#471F21] mb-4 flex items-center">
              <CheckCircle className="w-5 h-5 mr-2" />
              1. Booking & Payments
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>All bookings must be confirmed with a 100% advance payment to secure the slot.</li>
              <li>A refundable security deposit is required for all bookings to cover potential damages.</li>
              <li>The booking is valid only for the specified time slot. Extension of time is subject to availability and additional charges.</li>
              <li>Prices are subject to change without prior notice, but confirmed bookings will not be affected.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#471F21] mb-4 flex items-center">
              <CheckCircle className="w-5 h-5 mr-2" />
              2. Venue Usage & Conduct
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li><strong>Thaathayya Illu</strong> is a cultural space. We request guests to maintain the sanctity and decorum of the home.</li>
              <li><strong>Strictly Prohibited:</strong> Consumption of alcohol, smoking, and the use of illegal substances are strictly prohibited anywhere on the premises.</li>
              <li>Guests are responsible for their belongings. The management is not liable for theft or loss of personal items.</li>
              <li>Any furniture or props moved during the shoot/event must be placed back in their original position.</li>
              <li>Loud music that disturbs the neighborhood is not permitted.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#471F21] mb-4 flex items-center">
              <CheckCircle className="w-5 h-5 mr-2" />
              3. Damages & Liability
            </h2>
            <p className="mb-4">
              The booking party is responsible for any damage caused to the property, furniture, plants, or artifacts during the rental period.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Damages will be assessed after the event/photoshoot.</li>
              <li>Cost of repairs or replacement will be deducted from the security deposit.</li>
              <li>If the damage exceeds the deposit amount, the client is liable to pay the balance immediately.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#471F21] mb-4 flex items-center">
              <CheckCircle className="w-5 h-5 mr-2" />
              4. Photography & Filming
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Filming is permitted only in the booked areas. Private areas marked "No Entry" must be respected.</li>
              <li>Use of drones requires prior permission and must comply with local regulations.</li>
              <li>Nudity or content that violates public decency laws is strictly prohibited.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-[#471F21] mb-4 flex items-center">
              <CheckCircle className="w-5 h-5 mr-2" />
              5. Housekeeping
            </h2>
            <p>
              The venue is handed over in a clean condition. We expect it to be returned in a reasonably clean state. Excessive trash or mess may incur an additional cleaning fee.
            </p>
          </section>

          <div className="bg-[#FFF5E6] p-6 rounded-xl border border-[#471F21]/20 mt-8">
            <h3 className="font-bold text-[#471F21] mb-2 flex items-center">
              <AlertCircle className="w-5 h-5 mr-2" />
              Note to Guests
            </h3>
            <p className="text-sm">
              By proceeding with a booking at Thaathayya Illu, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <h3 className="font-bold text-[#471F21] mb-3">Legal Information</h3>
            <p className="text-sm text-gray-600">
              <strong>Proprietor:</strong> Karunasree Karamchati<br />
              <strong>Business Name:</strong> Thaathayya Illu<br />
              <strong>Address:</strong> South Block 102, Whitefields, Kondapur, Hyderabad, Telangana - 500084<br />
              <strong>Mobile:</strong> <a href="https://wa.me/9398235164" className="text-[#8B4446] hover:underline">+91 93982 35164</a><br />
              <strong>Email:</strong> <a href="mailto:thaathayyaillu@gmail.com" className="text-[#8B4446] hover:underline">thaathayyaillu@gmail.com</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;

